import { AIRiskBaselineEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getAIRiskQuestionnaries = async (): Promise<any> =>
  APIManager.sendGet(
    AIRiskBaselineEnds.GET_QUESTIONNARIES,
    true,
    {},
    {},
    axios
  );

const createAssessment = async (data: any): Promise<any> =>
  APIManager.sendPost(
    AIRiskBaselineEnds.CREATE_ASSESSMENT,
    data,
    true,
    {},
    {},
    axios
  );

const getAssessmentById = async (id: any): Promise<any> =>
  APIManager.sendGet(
    AIRiskBaselineEnds.GET_ASSESSMENT_ID(id),
    true,
    {},
    {},
    axios
  );

const getAIRiskAssessments = async (
  status: string,
  page: any = 1
): Promise<any> =>
  APIManager.sendGet(
    AIRiskBaselineEnds.GET_ASSESSMENT(status, page),
    true,
    {},
    {},
    axios
  );

const updateAssessment = async (id: any, data: any): Promise<any> =>
  APIManager.sendPut(
    AIRiskBaselineEnds.UPDATE_ASSESSMENT(id),
    data,
    true,
    {},
    {},
    axios
  );

const getAIRiskBaselineOverview = async (): Promise<any> =>
  APIManager.sendGet(
    AIRiskBaselineEnds.GET_AI_RISK_OVERVIEW,
    true,
    {},
    {},
    axios
  );

const deleteAssessment = async (id: string): Promise<any> =>
  APIManager.sendDelete(AIRiskBaselineEnds.DELETE(id), true, {}, {}, axios);

const downloadAssessment = async (id: string): Promise<any> =>
  APIManager.sendPost(
    AIRiskBaselineEnds.DOWNLOAD(id),
    {},
    true,
    {},
    { responseType: 'blob' },
    axios
  );

export const AIRiskBaselineService = {
  getAIRiskQuestionnaries,
  getAssessmentById,
  createAssessment,
  getAIRiskAssessments,
  updateAssessment,
  getAIRiskBaselineOverview,
  deleteAssessment,
  downloadAssessment,
};
